<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">系统设置</el-breadcrumb-item>
      <el-breadcrumb-item>系统参数配置</el-breadcrumb-item>
    </el-breadcrumb>
    <el-container>
      <el-main>
        <!-- 搜索筛选 -->
        <template>
          <el-form :model="editForm" ref="editForm"  :rules="rules">
            <el-form-item  label="程序LOGO" prop="logo">
              <br/>
              <el-upload
                class="avatar-uploader"
                :action="this.host+'/fileUpload/ossBatch'"
                :show-file-list="false"
                :on-success="handleAvatarSuccessOne"
                :before-upload="beforeAvatarUpload">
                <img v-if="editForm.logo" :src="editForm.logo" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <div slot="tip" class="el-upload__tip" style="font-size: 12px;color:#D1D1D1">程序LOGO，用于本程序图标</div>
              </el-upload>
            </el-form-item>
            <el-form-item label="程序名称" prop="name">
              <el-input size="small" v-model="editForm.name"  auto-complete="off" placeholder="请输入程序名称" style="width: 500px"></el-input>
              <div style="font-size: 12px;color:#D1D1D1">程序名称，在后台主标题上显示</div>
            </el-form-item>
            <el-form-item label="程序版本" prop="version">
              <el-input size="small" v-model="editForm.version"  auto-complete="off" placeholder="请输入程序版本" style="width: 500px"></el-input>
              <div style="font-size: 12px;color:#D1D1D1">程序版本，在后台主标题上标显示版本 v1</div>
            </el-form-item>
            <el-form-item label="网站名称" prop="website">
              <el-input size="small" v-model="editForm.website"  auto-complete="off" placeholder="请输入网站名称" style="width: 500px"></el-input>
              <div style="font-size: 12px;color:#D1D1D1">网站名称，将在浏览器的标签上显示 </div>
            </el-form-item>
            <el-form-item  label="浏览器图标" prop="browser">
              <br/>
              <el-upload
                class="avatar-uploader"
                :action="this.host+'/fileUpload/ossBatch'"
                :show-file-list="false"
                :on-success="handleAvatarSuccessTwo"
                :before-upload="beforeAvatarUpload">
                <img v-if="editForm.browser" :src="editForm.browser" class="avatara">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <div slot="tip" class="el-upload__tip" style="font-size: 12px;color:#D1D1D1">建议上传 ICO 图标的尺寸为 128x128</div>
              </el-upload>
            </el-form-item>
            <el-form-item label="网站备案号" prop="miitbeian">
              <el-input size="small" v-model="editForm.miitbeian"  auto-complete="off" placeholder="请输入网站备案号" style="width: 500px"></el-input>
              <div style="font-size: 12px;color:#D1D1D1">网站备案号，可以在<a href='https://beian.miit.gov.cn/#/Integrated/index' target="_blank" style="color: #1c6ca1">备案管理中心</a>查询获取，将在登录页面下面显示</div>
            </el-form-item>
            <el-form-item label="网站版权信息" prop="copyright">
              <el-input size="small" v-model="editForm.copyright"  auto-complete="off" placeholder="请输入网站版权信息" style="width: 500px"></el-input>
              <div style="font-size: 12px;color:#D1D1D1">网站版权信息，在后台登录页面显示版本信息并链接到备案到信息备案管理系统</div>
            </el-form-item>
          </el-form>
          <el-button size="small" type="primary" class="title"  :disabled="isDisabled" @click="submitForm('editForm')">保存</el-button>
        </template>
      </el-main>
    </el-container>
  </div>
</template>

<script>
  import {qryPlatform,upProgramRule} from '../../api/platformApi'
  export default {
    name: "program",
    data() {
      return {
        isDisabled: false,
        rules:{
          name: [
            { required: true, message: '程序名称不能为空', trigger: 'blur' }
          ],
          website: [
            { required: true, message: '网站名称不能为空', trigger: 'blur' }
          ],
          copyright: [
            { required: true, message: '网站版权信息不能为空', trigger: 'blur' }
          ],
          logo:[
            {required: true, message: '程序LOGO不能为空', trigger: 'blur'}
          ],
          browser:[
            {required: true, message: '浏览器图标不能为空', trigger: 'blur'}
          ]
        },
        editForm:{
          logo:'',
          name:'',
          version:'',
          website:'',
          browser:'',
          miitbeian:'',
          copyright:''
        }
      }
    },
    mounted() {
      this.qryPlatform();
    },
    methods:{
      qryPlatform(){
        var data={
          dataName:'PROGRAM_RULE'
        }
        qryPlatform(data)
          .then(res => {
            this.loading = false
            if (res.code!=1) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.editForm.logo=res.data.logo;
              this.editForm.name=res.data.name;
              this.editForm.version=res.data.version;
              this.editForm.website=res.data.website;
              this.editForm.browser=res.data.browser;
              this.editForm.miitbeian=res.data.miitbeian;
              this.editForm.copyright=res.data.copyright;
            }
          })
      },
      submitForm(editData) {
        this.isDisabled = true;
        this.$refs[editData].validate(valid => {
          if (valid) {
            upProgramRule(this.editForm).then(res =>{
              this.loading = false
              if (res.code==1) {
                this.$message({
                  type: 'success',
                  message: '数据保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
              this.isDisabled = false;
            }).catch(err => {
              this.$message.error('保存失败，请稍后再试！')
              this.isDisabled = false;
            })
          }else{
            this.isDisabled = false;
            return false
          }
        })

      },
      handleAvatarSuccessOne(res) {
        this.editForm.logo = res.data;
      },
      handleAvatarSuccessTwo(res) {
        this.editForm.browser = res.data;
      },
      beforeAvatarUpload(file) {
        //const isJPG = file.type === 'image/jpeg';
        const isLt2M = file.size / 1024 / 1024 < 2;

        /*if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG 格式!');
        }*/
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isLt2M;
      },
    },
    //分页组件
    components: {
    }
  }
</script>

<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/views/system/program.vue